import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import Tag from '../../../components/Tag';
import TooltipTrimmed from '../../../components/Tooltip/TooltipTrimmed';

export default function CardItem({ card }) {
  const color = card.template.color;
  const colorStyle = {
    color: color,
  };

  if (card.template.front.includes('card')) {
    return (
      <div key={card.id} className="th-card th-card-common">
        <Link to={`/cards/${card.id}`} className="d-block">
          <img src={card.logo} alt="card" alt="" className="th-card-child th-card-image" />
          <div
            className="th-card-child th-card-title"
            style={colorStyle}
          >
            {card.name}
          </div>
          <div className="th-card-child th-card-subtitle">
            <ul className="mr-auto">
              {card.types.map((type) => <Tag key={type.id} item={type} style={colorStyle} />)}
            </ul>
            <div className="logo-sm">
              <img src={logo} alt="" className="img-responsive" />
            </div>
          </div>
        </Link>
      </div>
    );
  }

  return (
    <div key={card.id} className="th-card th-card-special">
      <Link to={`/cards/${card.id}`} className="d-block color-white">
        <img src={card.logo} alt="card" alt="" className="th-card-child th-card-image" />
        <img src={card.template.front} alt="" className="th-card-child th-card-template" />
        <div className="th-card-child th-card-title">
          <TooltipTrimmed str={card.name} maxLength={45} />
        </div>
        <div className="th-card-child th-card-subtitle">
          <TooltipTrimmed str={card.place.address.full}
                          maxLength={45}
                          overlayClassName="text-center-children" />
        </div>
      </Link>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Cards/components/CardItem.js